// src/pages/Home.js
import React from "react";
import HeroSection from "./Components/HeroSection";
import Welcome from "./Components/Welcome";
import RecentMessages from "./Components/RecentMessages";
import FellowshipSection from "./Components/FellowshipSection";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <Welcome />
      <RecentMessages />
      <FellowshipSection />
    </div>
  );
}